export const adminEn = {
  admin: {
    dashboard: {
      title: 'Admin Dashboard',
      subtitle: 'Manage users, containers, and items',
      users: {
        title: 'Users',
        description: 'Manage user accounts and permissions',
        button: 'Manage Users',
      },
      containers: {
        title: 'Containers',
        description: 'View and manage all containers',
        button: 'Manage Containers',
      },
      items: {
        title: 'Items',
        description: 'View and manage all items',
        button: 'Manage Items',
      },
      limits: {
        title: 'Feature Limits',
        description: 'Configure AI and storage limits per role',
        button: 'Manage Limits',
      },
      reports: {
        title: 'Content Reports',
        description: 'Review and manage content reports',
        button: 'Manage Reports',
      },
      subscriptions: {
        title: 'Subscriptions',
        description: 'Manage user subscriptions and billing plans',
        button: 'Manage Subscriptions',
      },
    },
    users: {
      title: 'Users Management',
      subtitle: 'Manage user accounts and permissions',
      search: 'Search users...',
      loadError: 'Failed to load users',
      delete: 'Delete',
      deleteConfirm: 'Are you sure you want to delete this user?',
      deleteSuccess: 'User deleted successfully',
      deleteError: 'Failed to delete user',
      empty: 'No users found',
      emptyDescription: 'No users match your search criteria.',
      admin: 'Admin',
      user: 'User',
      active: 'Active',
      inactive: 'Inactive',
      verified: 'Verified',
      unverified: 'Unverified',
      makeUser: 'Make User',
      makePremium: 'Make Premium User',
      makeAdmin: 'Make Admin',
      roles: {
        user: 'User',
        admin: 'Admin',
        premium: 'Premium User',
      },
      changeRole: {
        action: 'change role to {role}',
        confirm: 'Are you sure you want to {action}?',
        success: 'User role changed to {role}',
        error: 'Failed to change user role',
      },
      toggleAdmin: {
        promote: 'Make Admin',
        demote: 'Remove Admin',
        confirm: 'Are you sure you want to {action}?',
        promoteSuccess: 'User promoted to administrator',
        demoteSuccess: 'User demoted from administrator',
        error: 'Failed to update user admin status',
      },
      columns: {
        name: 'Name',
        email: 'Email',
        isAdmin: 'Admin',
        role: 'Role',
        isActive: 'Active',
        isEmailVerified: 'Verified',
        createdAt: 'Created',
        actions: 'Actions',
      },
    },
    containers: {
      title: 'Containers Management',
      subtitle: 'View and manage all containers',
      search: 'Search containers...',
      loadError: 'Failed to load containers',
      deleteConfirm: 'Are you sure you want to delete this container?',
      deleteSuccess: 'Container deleted successfully',
      deleteError: 'Failed to delete container',
      empty: 'No containers found',
      emptyDescription: 'No containers match your search criteria.',
      public: 'Public',
      private: 'Private',
      columns: {
        name: 'Name',
        type: 'Type',
        author: 'Author',
        isPublic: 'Public',
        itemCount: 'Items',
        createdAt: 'Created',
        actions: 'Actions',
      },
    },
    items: {
      title: 'Items Management',
      subtitle: 'View and manage all items',
      search: 'Search items...',
      loadError: 'Failed to load items',
      deleteConfirm: 'Are you sure you want to delete this item?',
      deleteSuccess: 'Item deleted successfully',
      deleteError: 'Failed to delete item',
      empty: 'No items found',
      emptyDescription: 'No items match your search criteria.',
      columns: {
        name: 'Name',
        category: 'Category',
        container: 'Container',
        author: 'Author',
        quantity: 'Quantity',
        weight: 'Weight',
        status: 'Status',
        priority: 'Priority',
        createdAt: 'Created',
        actions: 'Actions',
      },
    },
    limits: {
      title: 'Feature Limits',
      subtitle: 'Configure AI and storage limits per user role',
      loadError: 'Failed to load limits',
      updateSuccess: 'Limit updated successfully',
      updateError: 'Failed to update limit',
      aiLimit: 'AI Limit (USD)',
      storageLimit: 'Storage Limit',
      unlimited: 'Unlimited',
      noAccess: 'No Access',
      unlimitedPlaceholder: 'Unlimited (leave empty)',
      aiLimitHint: 'Leave empty for unlimited, 0 for no access',
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      roles: {
        user: 'User',
        premium: 'Premium',
        admin: 'Admin',
        owner: 'Owner',
      },
    },
    reports: {
      title: 'Content Reports',
      subtitle: 'Review and manage content reports',
      search: 'Search reports...',
      filterByStatus: 'Filter by status',
      total: 'Total: {count}',
      updateSuccess: 'Report status updated',
      updateError: 'Failed to update report status',
      markReviewed: 'Mark as Reviewed',
      markDismissed: 'Mark as Dismissed',
      markActionTaken: 'Mark as Action Taken',
      makeContainerPrivate: 'Make Container Private',
      containerMadePrivate: 'Container made private',
      makePrivateError: 'Failed to make container private',
      actions: 'Actions',
      empty: 'No reports found',
      emptyDescription: 'There are no content reports matching your filters.',
      status: {
        all: 'All',
        pending: 'Pending',
        reviewed: 'Reviewed',
        dismissed: 'Dismissed',
        action_taken: 'Action Taken',
      },
      columns: {
        container: 'Container',
        reporter: 'Reporter',
        reason: 'Reason',
        status: 'Status',
        createdAt: 'Created',
        actions: 'Actions',
      },
    },
    subscriptions: {
      title: 'Subscription Management',
      subtitle: 'Manage user subscriptions and billing',
      search: 'Search subscriptions...',
      loadError: 'Failed to load subscriptions',
      empty: 'No subscriptions found',
      emptyDescription: 'No subscriptions match your search.',
      columns: {
        user: 'User',
        email: 'Email',
        plan: 'Plan',
        billing: 'Billing',
        status: 'Status',
        grandfathered: 'Grandfathered',
        actions: 'Actions',
      },
      plans: {
        free: 'Free',
        basic: 'Basic',
        pro: 'Pro',
      },
      billing: {
        monthly: 'Monthly',
        annual: 'Annual',
        month: 'Monthly',
        year: 'Annual',
      },
      status: {
        active: 'Active',
        canceled: 'Canceled',
        past_due: 'Past Due',
        unpaid: 'Unpaid',
        incomplete: 'Incomplete',
      },
      changeTo: {
        free: 'Change to Free',
        basic: 'Change to Basic',
        pro: 'Change to Pro',
      },
      changePlan: {
        confirm: 'Are you sure you want to change plan to {plan}?',
        success: 'Plan changed to {plan}',
        error: 'Failed to change plan',
      },
      makeGrandfathered: 'Make Grandfathered',
      removeGrandfathered: 'Remove Grandfathered',
      grandfathered: {
        add: 'grant grandfathered status',
        remove: 'remove grandfathered status',
        confirm: 'Are you sure you want to {action}?',
        success: 'Grandfathered status updated',
        error: 'Failed to update status',
      },
      cancel: {
        action: 'Cancel Subscription',
        confirm: 'Are you sure you want to cancel {plan} subscription? This will immediately cancel the subscription, downgrade to Free, and cancel in Stripe if applicable.',
        success: '{plan} subscription canceled successfully',
        error: 'Failed to cancel subscription',
      },
      stats: {
        totalUsers: 'Total Users',
        activeSubscriptions: 'Active Subscriptions',
        planDistribution: 'Plan Distribution',
        revenue: 'Revenue',
        grandfathered: 'Grandfathered Users',
        pastDue: 'Past Due',
        ofTotal: 'of {count} total',
        lifetimePro: 'Lifetime Pro access',
        requiresAttention: 'Requires attention',
        monthly: 'Monthly',
        annual: 'Annual',
      },
    },
  },
}
